import { type MouseEvent } from 'react';
import { RiskStatus } from '@/components/ui/RiskStatus';
import { AnalysisAccordion } from '../../common/AnalysisAccordion';
import toast from 'react-hot-toast';
import type { FileResultResponse } from '../../../../../types/api.types';
import { Text } from '@/components/ui/base/Text';
import { Row } from '@/components/ui/layout/Row';
import { PaperIcon } from '@/components/ui/icons/PaperIcon';
import { Column } from '@/components/ui/layout/Column';
import { PreviewPanelSkeleton } from './PreviewPanelSkeleton';

interface PreviewPanelProps {
  resultData?: FileResultResponse;
  isLoading?: boolean;
}

export const PreviewPanel = ({ resultData, isLoading }: PreviewPanelProps) => {
  const copyName = (e: MouseEvent<HTMLDivElement>) => {
    if (e.currentTarget.textContent) {
      navigator.clipboard.writeText(e.currentTarget.textContent);
      toast.success('Nom de fichier copié');
    }
  };

  if (isLoading) {
    return <PreviewPanelSkeleton />;
  }

  return (
    <Column gap="md" id="preview-section">
      <Row justify="start">
        <PaperIcon
          size={24}
          className="text-neutralText dark:text-neutralText-dark"
        />
        <Text
          data-tooltip-content={resultData?.nom}
          data-tooltip-id="tooltip"
          data-tooltip-place="top-start"
          data-tooltip-delay-show={100}
          data-tooltip-offset={5}
          onDoubleClick={copyName}
          size="lg"
          weight="medium"
          truncate
        >
          {resultData?.nom}
        </Text>
      </Row>

      <Row id="risk-section" justify="between">
        <Text weight="medium">Risque de fraude</Text>
        <RiskStatus risk={resultData?.risque ?? 0} />
      </Row>

      <Column>
        {resultData?.metadonnees &&
          Object.entries(resultData?.metadonnees || {})?.some(
            ([key]) =>
              key === 'Créateur' ||
              key === 'Date_de_création' ||
              key === 'Date_de_modification' ||
              key === 'Producteur'
          ) && (
            <AnalysisAccordion
              title="Metadonnées"
              variant="metadata"
              content={resultData?.metadonnees}
            />
          )}

        {resultData?.tests && (
          <AnalysisAccordion
            title="Tests"
            variant="tests"
            content={resultData?.tests}
          />
        )}
      </Column>
    </Column>
  );
};
